import { Grid, Header, Segment } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import DECISION from '../../constants/common/decision';

interface AutorisationFooterProps {
	decision: number;
	montant: number;
	total: number;
}

const AutorisationFooter = ({
	decision,
	montant,
	total,
}: AutorisationFooterProps) => (
	<Segment>
		<Grid>
			<Grid.Row columns={2}>
				<Grid.Column textAlign="center">
					<Header>
						<Header.Content>
							<span
								className={`autorisation${decision === DECISION.AP ? 'Programme' : 'Engagement'}Count`}
							>
								{total}
							</span>
							<Header.Subheader
								content={`Autorisation${total > 1 ? 's' : ''} ${decision === DECISION.AP ? 'de programme' : "d'engagement"}`}
							/>
						</Header.Content>
					</Header>
				</Grid.Column>
				<Grid.Column textAlign="center">
					<Header>
						<Header.Content>
							{formatMontant(montant)}
							<Header.Subheader content="Montant total" />
						</Header.Content>
					</Header>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	</Segment>
);

export default AutorisationFooter;
